import { connect } from 'react-redux';

import {
  getLabels,
  getProjectOriginalZoneId,
  getProjectZoneId,
  getUsageChartOptions,
  getUsageEvents,
} from '../../reducers/analyticsApp';
import { views } from '../../constants/event';
import LabelsChart from './LabelsChart';

const show = (events, view) =>
  events.some(({ result }) => !!result.rows.length) && view === views.CHART;

const mapStateToProps = (state) => ({
  zoneId: getProjectOriginalZoneId(state),
  userZoneId: getProjectZoneId(state),
  labels: getLabels(state),
  from: getUsageChartOptions(state).from,
  to: getUsageChartOptions(state).to,
  show: show(getUsageEvents(state), getUsageChartOptions(state).view),
});

export default connect(mapStateToProps)(LabelsChart);
